export var source = "query RefundInquiry($input: RefundInquiryInput!) {\n  currentUser {\n    data {\n      subscription {\n        refundInquiry(input: $input) {\n          status\n        }\n      }\n    }\n  }\n}";
export default source;